export default __webpack_public_path__ + "static/media/carbon_floorplan.1627aa53.svg";